import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  form: {
    maxWidth: 320,
    margin: '20px auto 0'
  },
  formFooter: {
    justifyContent: 'center',
    marginTop: 24
  }
})

export default useStyles
